<template>
  <div class="g-main">
    <Header class="g-header" />
    <router-view class="g-bd" :key="key" />
    <Footer class="g-ft" />

    <!--网上报名-->
    <div class="g-signUp" v-if="false">
      <div class="hd">
        <div class="hd-cap">我要报名</div>
        <div
          class="hd-btn m-h mla"
          :class="{ small: signUpSmall }"
          @click="signUpSmall = !signUpSmall"
        ></div>
      </div>
      <div class="bd" v-if="!signUpSmall">
        <el-form :model="form" :rules="rules" ref="form" class="g-signUp-form">
          <el-form-item prop="name" class="name">
            <el-input v-model="form.name" placeholder="姓名（必填）"></el-input>
          </el-form-item>
          <el-form-item prop="phone" class="phone">
            <el-input
              v-model="form.phone"
              placeholder="手机号（必填）"
            ></el-input>
          </el-form-item>
          <div class="g-signUp-form-ft">
            <div class="g-signUp-form-btn m-h" @click="onSubmit">提交</div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/kf-footer";
import { Form, FormItem, Input, Message } from "element-ui";

export default {
  data() {
    return {
      form: {
        name: "",
        phone: "",
        channel: "运营营销",
        address: "http://www.huabote.com/"
      },
      rules: {
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        phone: [
          { required: true, validator: this.$fun.form.phone, trigger: "blur" }
        ]
      },
      signUpSmall: false
    };
  },
  components: {
    Header,
    Footer,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-input": Input
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    }
  },
  mounted() {},
  methods: {
    onSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$api.ums.promote.backgroundMessage_messageForClient
            .post(this.form)
            .then(() => {
              Message.success("提交成功，请耐心等待老师与您联系");
              this.$refs["form"].resetFields();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less">
.g-main {
  height: 100%;
  min-width: 1200px;
}
.g-bd {
  box-sizing: border-box;
  min-height: 516px;
}
.g-signUp {
  position: fixed;
  left: 0;
  bottom: 0;
  border-radius: 5px;
  background-color: #ededed;
  z-index: 100;
  width: 240px;
  .hd {
    height: 35px;
    display: flex;
    align-items: center;
    background-color: #00aef3;
    border-radius: 5px 5px 0 0;
    padding: 0 12px;
  }
  .hd-cap {
    font-size: 14px;
    color: #fff;
  }
  .hd-btn {
    background: url("../assets/img/ico_31.png") no-repeat center;
    width: 34px;
    height: 30px;
    &.small {
      background-image: url("../assets/img/ico_32.png");
    }
  }
  .bd {
    padding: 15px 8px 15px 8px;
  }
}
.g-signUp-form {
  .el-form-item {
    margin-bottom: 20px;
    &.name,
    &.phone {
      .el-input__inner {
        font-size: 12px;
        height: 35px;
        line-height: 35px;
        padding-left: 30px;
        box-sizing: border-box;
        background-repeat: no-repeat;
        background-position: 8px center;
        border: 1px solid #d5d5d5;
        &::placeholder {
          color: #999;
        }
      }
    }
    &.name {
      .el-input__inner {
        background-image: url("../assets/img/ico_29.png");
      }
    }
    &.phone {
      .el-input__inner {
        background-image: url("../assets/img/ico_30.png");
      }
    }
  }
  .el-form-item__content {
    height: 35px;
    line-height: 35px;
  }
}
.g-signUp-form-ft {
  padding-top: 10px;
}
.g-signUp-form-btn {
  height: 30px;
  width: 80px;
  line-height: 30px;
  text-align: center;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  background-color: #00aef3;
}
</style>
